import { Grid2 as Grid, Button, Typography, Box } from "@mui/material"
import { EEslTemplateElementType } from "../../../models/enums/eslTemplateType"
import { theme } from "../../../styles/themes/mainTheme"
import TextFieldsIcon from '@mui/icons-material/TextFields';
import NotesIcon from '@mui/icons-material/Notes';
import ImageIcon from '@mui/icons-material/Image';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import RectangleIcon from '@mui/icons-material/Rectangle';
import CircleIcon from '@mui/icons-material/Circle';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import { IOnAddElementProps } from "./Sidebar";
import { useTranslation } from "react-i18next";
import IEslTemplateItem from "../../../models/esl/eslTemplateElement";

interface IElementsGridProps {
  onAddElement: ({ type, customStyle, customDimensions }: IOnAddElementProps) => void
  currentElements: IEslTemplateItem[]
}

const BLACK = '#000000';

const ElementPicker = ({ onAddElement, currentElements }: IElementsGridProps) => {
  const { t } = useTranslation(['eslTemplate', 'common']);

  const elementConfigs = [
    {
      type: EEslTemplateElementType.Text,
      icon: <TextFieldsIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.Text]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.Text, customDimensions: { width: 100, height: 30 } }),
    },
    {
      type: EEslTemplateElementType.MultilineText,
      icon: <NotesIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.MultilineText]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.MultilineText, customDimensions: { width: 100, height: 100 } }),
    },
    {
      type: EEslTemplateElementType.Image,
      icon: <ImageIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.Image]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.Image }),
    },
    {
      type: EEslTemplateElementType.Line,
      icon: <HorizontalRuleIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.Line]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.Line, customDimensions: { width: 300, height: 5 }, customStyle: { backgroundColor: BLACK } }),
    },
    {
      type: EEslTemplateElementType.Rectangle,
      icon: <RectangleIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.Rectangle]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.Rectangle, customStyle: { backgroundColor: BLACK } }),
    },
    {
      type: EEslTemplateElementType.Circle,
      icon: <CircleIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.Circle]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.Circle, customStyle: { backgroundColor: BLACK } }),
    },
    {
      type: EEslTemplateElementType.LastCleaningDatetime,
      icon: <AccessTimeIcon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.LastCleaningDatetime]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.LastCleaningDatetime, customDimensions: { width: 210, height: 120 } }),
      isDisabled: currentElements.some((element) => element.type === EEslTemplateElementType.LastCleaningDatetime)
    },
    {
      type: EEslTemplateElementType.ServiceRequestQRCode,
      icon: <QrCode2Icon fontSize="large" />,
      label: t(`eslTemplate:templateEditor.elementsPicker.${EEslTemplateElementType[EEslTemplateElementType.ServiceRequestQRCode]}`),
      onClick: () => onAddElement({ type: EEslTemplateElementType.ServiceRequestQRCode, customDimensions: { width: 120, height: 120 } }),
      isDisabled: currentElements.some((element) => element.type === EEslTemplateElementType.ServiceRequestQRCode)
    },
  ];

  return (
    <Box>
      <Typography variant="h6">{t('eslTemplate:templateEditor.elementsPicker.title')} </Typography>
      <Grid container spacing={2} sx={{ textAlign: 'center' }}>
        {elementConfigs.map((config, index) => (
          <Grid key={index} size={4} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={config.onClick} disabled={config.isDisabled} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {config.icon}
              <Typography variant="body2" color={theme.palette.text.primary}>
                {config.label}
              </Typography>
            </Button>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default ElementPicker